import { render, staticRenderFns } from "./user-info.vue?vue&type=template&id=33badbd3&"
import script from "./user-info.vue?vue&type=script&lang=js&"
export * from "./user-info.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\公司文件\\web\\uni-platform\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('33badbd3')) {
      api.createRecord('33badbd3', component.options)
    } else {
      api.reload('33badbd3', component.options)
    }
    module.hot.accept("./user-info.vue?vue&type=template&id=33badbd3&", function () {
      api.rerender('33badbd3', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/router/views/user-manage/user-accounts/user-info.vue"
export default component.exports